import { render, staticRenderFns } from "./PageAssortment.vue?vue&type=template&id=52b99b9e&scoped=true&"
import script from "./PageAssortment.vue?vue&type=script&lang=js&"
export * from "./PageAssortment.vue?vue&type=script&lang=js&"
import style0 from "./PageAssortment.vue?vue&type=style&index=0&id=52b99b9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b99b9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
